import React from 'react';
import { ReactComponent as NEXT } from '../../assets/IconsColurs/IconsGeneral/chevronRightBlanco.svg';
import ColorsMain from '../../colors/ColorsMain';
import { ReactComponent as CHECK } from '../../assets/IconsColurs/IconsGeneral/noCheck.svg';


const ButtonStepReview = ({ label, completedTasks = null, totalTasks = null, Icon, onClick, check = false }) => {
  const taskColor = completedTasks < totalTasks ? ColorsMain.errorBorder : ColorsMain.texttMain;

  return (
    <button
      onClick={onClick}
      className="flex items-center gap-4 w-full p-5 rounded-lg bg-[#26262D] backdrop-blur-[50px] text-white"
      style={{
        padding: 'var(--spacing-l, 20px) var(--spacing-xl, 24px)',
        borderRadius: 'var(--radius-m, 12px)',
      }}
    >
      {/* Indicador de tareas completadas */}
      {completedTasks != null && totalTasks != null && <span className="text-sm">
        <span style={{ color: taskColor }}>{completedTasks}</span>
        <span style={{ color: '#8A8A8E' }}>/{totalTasks}</span>
      </span>}

      {/* Título */}
      <span className="text-sm font-semibold flex-1">{label}</span>

      {/* Ícono (opcional) */}
      {check && <CHECK className="w-6 h-6" />}
      {Icon && !check && <Icon className="w-6 h-6 text-gray-400" />}
      {!Icon && !check && <NEXT className="w-6 h-6 text-gray-400" />}
    </button>
  );
};

export default ButtonStepReview;
